import { render, staticRenderFns } from "./DeleteChargeModal.vue?vue&type=template&id=1dfc1534&scoped=true&"
import script from "./DeleteChargeModal.vue?vue&type=script&lang=js&"
export * from "./DeleteChargeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfc1534",
  null
  
)

export default component.exports